import * as React from 'react';
import CallIcon from '@mui/icons-material/Call';
import { CheckboxField, Modal } from 'src/shared/ui/elements';
import { ChatOutlined, FileCopyOutlined } from '@mui/icons-material';
import { showToastMessage } from 'src/coach/service/coach.utils';

export const ParentContactsModal = ({ guardians = [], $actions }) => {
  const [selected, setSelected] = React.useState([]);
  const uniqGuardians = [...guardians];
  const handleCall = (phone) => {
    window.open(`tel:${phone}`, '_self');
  };
  const handleMessage = (phone) => {
    window.open(`sms:${phone}`, '_self');
  };
  const handleGroupMessage = () => {
    const phones = uniqGuardians.map((guardian) => guardian.phone).join(',');
    window.open(`sms:${phones}`, '_self');
  };

  const handleSelectionChange = (checked, id) => {
    if (checked) {
      setSelected([...selected, id]);
    } else {
      setSelected(selected.filter((el) => el !== id));
    }
  };

  const copy = (text) => {
    navigator.clipboard.writeText(text);
    showToastMessage('Copied to clipboard');
  };
  return (
    <Modal $title="Parent Contacts" $actions={$actions}>
      <div className="pl-16 pr-16 pb-24">
        {uniqGuardians.map((guardian, index) => (
          <div
            className="flex align-center justify-space-between mb-16 pb-6 bcb-gray-85 mt-16"
            key={index}
          >
            <div className="flex tw-items-center tw-gap-2">
              {uniqGuardians?.length > 1 && (
                <div>
                  <CheckboxField
                    name={`order-${guardian.id}-selection`}
                    $label=""
                    labelClassName="fs-14 fw-500"
                    checked={selected.includes(guardian.id)}
                    onChange={(event) =>
                      handleSelectionChange(event.target.checked, guardian?.id)
                    }
                  />
                </div>
              )}
              <div className="flex tw-my-2 tw-flex-col">
                <span className="fs-16 capitalize">{guardian?.fullName}</span>
                <div>
                  <span className="fs-11 capitalize">
                    {guardian?.type}{' '}
                    {guardian?.isAccountHolder && '(Account Holder)'}
                  </span>
                  <span
                    className="fs-11 flex tw-items-center tw-gap-2"
                    onClick={() => copy(guardian?.phone)}
                  >
                    Phone: ({guardian?.phone})
                    <FileCopyOutlined
                      className="pointer primary"
                      style={{ fontSize: 14 }}
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="flex tw-items-center tw-gap-4">
              <div
                className="flex tw-items-center tw-flex-col pointer"
                onClick={() => handleCall(guardian?.phone)}
              >
                <CallIcon color="primary" />
                <span className="fs-11">Call </span>
              </div>
              <div
                className="flex tw-items-center tw-flex-col pointer"
                onClick={() => handleMessage(guardian?.phone)}
              >
                <ChatOutlined color="primary" />
                <span className="fs-11">Message </span>
              </div>
            </div>
          </div>
        ))}

        {uniqGuardians.length > 1 && selected.length > 1 && (
          <div className="flex tw-items-center pointer tw-justify-self-end">
            <div
              className="flex tw-flex-col tw-items-center"
              onClick={handleGroupMessage}
            >
              <ChatOutlined color="primary" />
              <span className="fs-11">Group Message </span>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};
